import { Injectable } from '@angular/core';
import * as loadGoogleMapsAPI from 'load-google-maps-api';
import { environment } from '../../environments/environment';
import { SettingsService } from './settings.service';

@Injectable()
export class GoogleMapsService {
  api: Promise<any>;

  constructor(private settings: SettingsService) {
    this.api = loadGoogleMapsAPI({
      key: environment.googleAccessToken,
      libraries: ['places'],
      language: settings.getLanguage()
    });
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/services/google-maps.service.ts